import React, { useCallback, useMemo, useState } from 'react';
import Container from 'components/UI/Container';
import { CustomDot, CustomPagination } from 'components/UI/Slider/utils';
import TopProjectSlide from './TopProjectSlide';
import { pushCustomEvent } from 'utils/analytics';
import { isRequestedFrom, useLang } from 'utils/localisation';
import { withErrorBoundary } from 'components/ErrorBoundary';
import Slider from 'components/UI/Slider';
import { isSsr } from 'define';
import { germanRegion } from 'define/locale';

import * as styles from './TopProjects.module.scss';

import topProjectData from './top-projects.json';

function TopProjects() {
  const lang = useLang();
  const isEnglishLang = lang === 'en' || lang === 'kz' || lang === 'pl' || lang === 'uk';

  const [current, setCurrent] = useState(0);

  const setCurrentKey = useCallback((prev, next) => {
    setCurrent(next);
  }, []);

  const topProjects = useMemo(() => {
    if (!isSsr) {
      if (isEnglishLang && isRequestedFrom(germanRegion)) {
        return topProjectData.en.dach;
      }

      return topProjectData?.[lang]?.default ?? topProjectData.en.default;
    }
  }, [topProjectData, lang, isSsr]);

  const sliderSettings = useMemo(
    () => ({
      customPaging: CustomDot.bind(null, topProjects?.length, current),
      appendDots: CustomPagination,
      dotsClass: 'slick-pagination',
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 0,
      arrows: true,
      infinite: true,
      responsive: [
        {
          breakpoint: 940,
          settings: {
            arrows: false,
            dots: true,
          },
        },
      ],
    }),
    [topProjects?.length, current],
  );

  const handlePushEvent = action => {
    pushCustomEvent('ndrsn_top_projects_component', {
      action,
    });
  };

  const pushEvent = () => {
    handlePushEvent('slide_change');
  };

  return (
    <Container id="concepts-list" padding="Without" background="transparent">
      <div className="defaultSliderDarkBg">
        <Slider
          {...sliderSettings}
          beforeChange={setCurrentKey}
          afterChange={pushEvent}
          className={styles.slider}
        >
          {topProjects?.map(item => (
            <TopProjectSlide key={item.title} {...item} handlePushEvent={handlePushEvent} />
          ))}
        </Slider>
      </div>
    </Container>
  );
}

TopProjects.displayName = 'TopProjects';

export default withErrorBoundary(TopProjects);
